"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sharedTemplateEmptySearchError = exports.sharedTemplateExtLink = exports.sharedTemplateAutoComplete = exports.sharedTemplateLocale = exports.sharedTemplateFreeText = exports.sharedTemplateButton = exports.GRID_AREAS = void 0;
/**
 * The funcitons in here house all the common styles across all the templates, which happens
 * to be mostly the styles that are managed in SWAT (colors, fonts, etc.). Template-specific
 * styles are in the individual template files
 */
// put the grid-area strings in 1 place to eliminate typos
exports.GRID_AREAS = {
    searchLabel: 'searchLabel',
    searchInput: 'searchInput',
    searchError: 'searchError',
    localeLabel: 'localeLabel',
    localeInput: 'localeInput',
    searchButton: 'searchButton',
    externalLink: 'externalLink'
};
const sharedTemplateButton = (theme) => `
  grid-area: ${exports.GRID_AREAS.searchButton};
  button {
    background-color: ${theme.sw_color_button};
    border: 1px solid ${theme.sw_color_button};
    color: ${theme.sw_color_button_text}; 
    font-family: ${theme.sw_font_face_button};
    font-size: ${theme.sw_font_size_button};
    font-weight: ${theme.sw_font_weight_button};
    cursor: pointer;

    &:hover {
      background-color: ${theme.sw_color_button_hover};
      border: 1px solid ${theme.sw_color_button_hover};
    }

    &:active {
      background-color: ${theme.sw_color_button_active};
      border: 1px solid #FFF;
      outline-color: ${theme.sw_color_button_active};
      outline-width: 2px;
      outline-style: solid;
      outline-offset: 2px;
    }

    &:disabled {
      background-color: ${theme.sw_color_button_disabled};
      border: 1px solid ${theme.sw_color_button_disabled};
      cursor: not-allowed;
    }

    &:focus {
      background-color: ${theme.sw_color_button_hover};
      border: 1px solid #FFF;
      outline-color: ${theme.sw_color_button_hover};
      outline-width: 2px;
      outline-style: solid;
      outline-offset: 2px;
    }

    svg {
      position: relative;
      color: ${theme.sw_color_button_text}; 
      font-size: ${theme.sw_font_size_button};
      path {
        color: inherit;
      }
    }

    span {
      margin-left: 3px;
      color: ${theme.sw_color_button_text}; 
      font-size: ${theme.sw_font_size_button};
    }
  }
`;
exports.sharedTemplateButton = sharedTemplateButton;
const sharedTemplateFreeText = (theme) => ({
    label: `
    // override PMC styles (insulate)
    display: inline;
    text-indent: 0;
  
    grid-area: ${exports.GRID_AREAS.searchLabel};
    color: ${theme.sw_color_label_search};
    font-family: ${theme.sw_font_face_label_search};
    font-size: ${theme.sw_font_size_label_search};
    font-weight: ${theme.sw_font_weight_label_search};
    margin-bottom: ${theme.sw_spacing_xsmall};
    padding: 0;
  `,
    input: `
    grid-area: ${exports.GRID_AREAS.searchInput};
    input {
      border: 1px solid ${theme.sw_color_border_input_search};
      color: ${theme.sw_color_input_search};
      font-family: ${theme.sw_font_face_input_search};
      font-size: ${theme.sw_font_size_input_search};
      font-weight: ${theme.sw_font_weight_input_search};
      margin: 0;
      padding: ${theme.sw_spacing_small};
      width: 100%;
      &:focus, &:focus-visible {
        outline-color: ${theme.sw_color_outline_input_search};
        outline-style: solid;
      }
      &::placeholder {
        color: ${theme.sw_color_text_placeholder_search};
      }
      &[data-error=true]  {
        background-color: ${theme.sw_color_background_input_error};
        border-color: ${theme.sw_color_border_input_error};
      }
    }

    div.sw-input-container {
      position: relative;
    }

    div.sw-spinner-container {
      position: absolute;
      left: calc(100% - 20px);
      top: 10%;

      > span > span {
        border-color: ${theme.sw_color_button};
        background-color: ${theme.sw_color_button};
      }
    }
  `
});
exports.sharedTemplateFreeText = sharedTemplateFreeText;
const sharedTemplateLocale = (theme) => ({
    label: `
    // override PMC styles (insulate)
    display: inline;
    text-indent: 0;
  
    grid-area: ${exports.GRID_AREAS.localeLabel};
    color: ${theme.sw_color_label_location};
    font-family: ${theme.sw_font_face_label_location};
    font-size: ${theme.sw_font_size_label_location};
    font-weight: ${theme.sw_font_weight_label_location};
    margin-bottom: ${theme.sw_spacing_xsmall};
    padding: 0;
  `,
    input: `
    grid-area: ${exports.GRID_AREAS.localeInput};
    input {
      border: 1px solid ${theme.sw_color_border_input_location};
      color: ${theme.sw_color_input_location};
      font-family: ${theme.sw_font_face_input_location};
      font-size: ${theme.sw_font_size_input_location};
      font-weight: ${theme.sw_font_weight_input_location};
      margin: 0;
      padding: ${theme.sw_spacing_small};
      width: 100%;
      &:focus, &:focus-visible {
        outline-color: ${theme.sw_color_outline_input_location};
        outline-style: solid;
      }
      &::placeholder {
        color: ${theme.sw_color_text_placeholder_location};
      }
    }
  `
});
exports.sharedTemplateLocale = sharedTemplateLocale;
const sharedTemplateAutoComplete = (theme) => ({
    listItem: `
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;

    &:focus,
    &:hover,
    &[data-focus=true] {
      background-color: ${theme.sw_color_suggest_item_hover};
    }

    & > svg {
      font-size: ${theme.sw_font_size};
      margin: 0 ${theme.sw_spacing_medium} 4px ${theme.sw_spacing_medium};
      color: ${theme.sw_color_suggest_item_value};
      path {
        color: inherit;
      }

      // prevent list icon from shrinking 
      // should be kept the same size as the icon
      min-width: 1em;
    }
    
    & > div {
      span {
        // Autosuggest "provider name"
        font-size: ${theme.sw_font_size};
        color: ${theme.sw_color_suggest_item_value};
        font-weight: ${theme.sw_font_weight_suggest_item_value};
        &:nth-of-type(2n) {
          // Autosuggest "provider category"
          color: ${theme.sw_color_suggest_item_key};
          font-weight: ${theme.sw_font_weight_suggest_item_key};
        }

        em {
          color: inherit;
          font-weight: ${theme.sw_font_weight_bold};
          font-style: normal;
          font-size: ${theme.sw_font_size};
        }
        
        span.category-text {
          color: ${theme.sw_color_suggest_item_key};
        }
      }
    }
  `,
    popper: `
    background-color: ${theme.sw_color_suggest_color};
    border: 1px ${theme.sw_color_border_suggest} solid;
    box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.15);
    margin-top: ${theme.sw_spacing_small};
    position: absolute;
    overflow: hidden;
    color: ${theme.sw_color_suggest_item_value};

    .MuiPaper-root {
      // MUI adds a box shadow that creates an additional bottom border here
      box-shadow: none;
      // MUI also makes the background color white, so need this here too
      background-color: ${theme.sw_color_suggest_color};
    }

    ul {
      padding: 0;
      margin: 0;
    }

    li {
      padding: ${theme.sw_spacing_small} 0;
      color: ${theme.sw_color_suggest_item_value};
      font-size: ${theme.sw_font_size};
      margin: 0;
      line-height: 1.5;
      list-style: none;
      // MUI alters this 
      letter-spacing: initial;
    }

    li.group {
      border-top: 1px ${theme.sw_color_border_suggest} solid;
    }
    li.group:first-of-type {
      border-top: none;
    }

    li:not(.group) {
      border: 1px solid transparent;

      &:hover,
      &:focus,
      &:focus-visible,
      &.Mui-focused {
        background-color: ${theme.sw_color_suggest_item_hover};
        border: 1px solid ${theme.sw_color_suggest_item_focus_border};
      }
    }

    div {
      font-family: ${theme.sw_font_face};
      font-size: ${theme.sw_font_size};
    }
  `,
    chipContainer: `
    align-items: center;
    display: flex;
    margin: ${theme.sw_spacing_medium} ${theme.sw_spacing_small};
    width: 100%;
    overflow: scroll;
  `,
    chip: `
    border-radius: ${theme.sw_border_radius_chip};
    border: 1px ${theme.sw_color_border} solid;
    color: ${theme.sw_color_chip_text};
    background-color: ${theme.sw_color_chip};
    cursor: pointer;
    margin-right: ${theme.sw_spacing_small};
    padding: ${theme.sw_spacing_small} ${theme.sw_spacing_medium};
    transition: background-color 0.2s ease;
    white-space: nowrap;

    &:hover,
    &.active {
      background-color: ${theme.sw_color_chip_hover};
      color: ${theme.sw_color_chip_hover_text};
    }
  `,
    groupHeading: `
    display: block;
    padding: 0 ${theme.sw_spacing_small};
    color: ${theme.sw_color_suggest_item_key};
    font-weight: ${theme.sw_font_weight_suggest_item_key};
    font-size: ${theme.sw_font_size};
  `
});
exports.sharedTemplateAutoComplete = sharedTemplateAutoComplete;
const sharedTemplateExtLink = (theme) => `
  grid-area: ${exports.GRID_AREAS.externalLink};
  font-family: ${theme.sw_ext_link_font_face};
  font-size: ${theme.sw_ext_link_font_size};
  margin-top: ${theme.sw_spacing_medium};
  color: ${theme.sw_ext_link_text_color}; 

  a, a:visited {
    font-weight: normal;
    font-family: ${theme.sw_ext_link_font_face};
    font-size: ${theme.sw_ext_link_font_size};
    color: ${theme.sw_ext_link_color}
  }
`;
exports.sharedTemplateExtLink = sharedTemplateExtLink;
const sharedTemplateEmptySearchError = (theme) => `
  grid-area: ${exports.GRID_AREAS.searchError};
  color: ${theme.sw_color_label_error};
  font-family: ${theme.sw_font_face_label_error};
  font-size: ${theme.sw_font_size_label_error};
  font-weight: ${theme.sw_font_weight_label_error};
  margin: ${theme.sw_spacing_xsmall} 0;
`;
exports.sharedTemplateEmptySearchError = sharedTemplateEmptySearchError;
//# sourceMappingURL=common.js.map